import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { sortTimeSlots } from './timeSlots';

const { Types, Creators } = createActions({
  getRecommendedCourses: ['courseId', 'date', 'limit'],
  getRecommendedCoursesDone: ['nearbyCourses', 'coursesWithHotDeals'],
  getRecommendedCoursesError: ['errorMessage'],
  getRecommendedTeeTimes: ['teeTimeId', 'qty', 'limit'],
  getRecommendedTeeTimesDone: ['teeTimes'],
  getRecommendedTeeTimesError: ['errorMessage'],
});

export const RecommendationTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable.from({
  coursesNearby: [],
  coursesWithHotDeals: [],
  recommendedTeeTimes: [],
  isFetchingRecommendedCourses: false,
  isFetchingRecommendedCoursesDone: false,
  fetchingRecommendedCoursesError: '',
  isFetchingRecommendedTeeTimes: false,
  isFetchingRecommendedTeeTimesDone: false,
  fetchingRecommendedTeeTimesError: '',
});

const getRecommendedCourses = (state) => state.merge({
  isFetchingRecommendedCourses: true,
  isFetchingRecommendedCoursesDone: false,
  fetchingRecommendedCoursesError: '',
});

const getRecommendedCoursesDone = (state, { nearbyCourses, coursesWithHotDeals }) => state.merge({
  coursesNearby: nearbyCourses,
  coursesWithHotDeals,
  isFetchingRecommendedCourses: false,
  isFetchingRecommendedCoursesDone: true,
  fetchingRecommendedCoursesError: '',
});

const getRecommendedCoursesError = (state, { errorMessage }) => state.merge({
  isFetchingRecommendedCourses: false,
  isFetchingRecommendedCoursesDone: true,
  fetchingRecommendedCoursesError: errorMessage,
});

const getRecommendedTeeTimes = (state) => state.merge({
  isFetchingRecommendedTeeTimes: true,
  isFetchingRecommendedTeeTimesDone: false,
  fetchingRecommendedTeeTimesError: '',
});

const getRecommendedTeeTimesDone = (state, { teeTimes }) => state.merge({
  recommendedTeeTimes: sortTimeSlots(teeTimes, 'time'),
  isFetchingRecommendedTeeTimes: false,
  isFetchingRecommendedTeeTimesDone: true,
  fetchingRecommendedTeeTimesError: '',
});

const getRecommendedTeeTimesError = (state, { errorMessage }) => state.merge({
  isFetchingRecommendedTeeTimes: false,
  isFetchingRecommendedTeeTimesDone: true,
  fetchingRecommendedTeeTimesError: errorMessage,
});

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_RECOMMENDED_COURSES]: getRecommendedCourses,
  [Types.GET_RECOMMENDED_COURSES_DONE]: getRecommendedCoursesDone,
  [Types.GET_RECOMMENDED_COURSES_ERROR]: getRecommendedCoursesError,
  [Types.GET_RECOMMENDED_TEE_TIMES]: getRecommendedTeeTimes,
  [Types.GET_RECOMMENDED_TEE_TIMES_DONE]: getRecommendedTeeTimesDone,
  [Types.GET_RECOMMENDED_TEE_TIMES_ERROR]: getRecommendedTeeTimesError,
});
